<template>
	<div class="wrap">
		<Add :moreAddwin="moreAddwin" :uid="uid" @closeUpload="closeUpload"></Add>
		<Preview ref="preview" :previeWin="previeWin" @closePreview="closePreview"></Preview>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>党员管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="switchBar">
						<span :class="{selectSwitch:transferType == 1}" @click="transferType=1;dataList()">党员转出</span>
						<span :class="{selectSwitch:transferType == 2}" @click="transferType=2;dataList()">党员接收</span>
					</div>
					<div class="selectbar">
						<div>
							<el-select
								size="small"
							 	style="margin-right: 10px;width: 120px !important;" 
								v-model="getdata.transfer" :placeholder="transferType==1?'转出状态':'转入状态'"
								clearable
								@change="dataList();">
								<el-option
									label="待接收"
									value="1">
								</el-option>
								<el-option
									v-if="transferType==2"
									label="已转入"
									value="2">
								</el-option>
								<el-option
									v-if="transferType==1"
									label="已转出"
									value="2">
								</el-option>
								<el-option
									label="未通过"
									value="3">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" @click="$router.push('/gxzy_add')" v-if="$store.state.user.userinfo.flag!=2">党员转出</el-button>
							<el-button type="primary" size="small" @click="daochu">导出表格</el-button>
							<el-button type="danger" size="small" @click="delall">一键删除</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="false"
							:selection="true">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/tree.vue'
	import { dygl,dwgl } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import myTables from '@/components/tables/tables.vue'
	import Add from './components/add.vue'
	import Preview from './components/preview.vue'
	let that;
	export default{
		data(){
			return{
				transferType:1,
				getdata:{
					zbid: this.$store.state.user.userinfo.id,
					flag: this.$store.state.user.userinfo.flag,
					transfer: "",
					page: 1
				},
				type:1,//1：新增 2：批量新增
				tableData:[],
				totalPage:0,
				moreAddwin:false,
				previeWin:false,
				uid:'',
				zhiwulist:dygl.dyclass(),//身份筛选列表
				tableHeader: [     // 表头
					{prop: 'u_name', label: '姓名',width:'100'},
					{prop: 'out_name', label: '转出组织',width:''},
					{prop: 'into_name', label: '转入组织'},
					{prop: 'addtime', label: '申请时间',width:'100',formatData:function(val){
						return that.$changeTime(val)
					}},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '介绍信', width: '114',align:'center',
						oper: [
							{name: '预览', style: {color:'#bb0000'}, clickFun: this.detailIntro,show:true,limit:''},
						]
					},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '回执', width: '114',align:'center',
						oper: [
							{name: '预览', style: {color:'#bb0000'}, clickFun: this.detailBack,show:true,limit:''},
						]
					},
					{prop: 'transfer', label: '转出状态',width:'120',formatData:function(val){
						switch(true){
							case val == 1: return '待接收';break;
							case val == 2&&that.transferType == 1: return '已转出';break;
							case val == 2&&that.transferType == 2: return '已转入';break;
							case val == 3: return '未通过审批';break;
							default:break;
						}
					}},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '114',align:'center',
						oper: [
							{name: '详情', style: {color:'#bb0000'}, clickFun: this.detail,show:true,limit:''},
							{name: '上传', style: {color:'#bb0000'}, clickFun: this.openUpload,show:true,limit:''},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del,show:true,limit:''}
						]
					}
				]
			}
		},
		components:{Page,myTables,Add,Preview},
		created(){that = this},
		methods:{
			// 关闭新增或编辑弹窗
			closeWin(){
				this.dialogVisible = false;
			},
			// 打开上传窗口
			openUpload(data){
				that.uid = data.uid;
				that.moreAddwin = true;
			},
			del(data){
				
			},
			delall(){
				
			},
			closeUpload(){
				that.uid ="";
				that.moreAddwin = false;
				that.dataList();
			},
			// 介绍信预览
			detailIntro(data){
				if(data.is_recei){
					that.previeWin = true;
					that.$refs.preview.bindData(data.uid,1);
				}else{
					Message.warning("未上传")
				}
			},
			// 回执
			detailBack(data){
				if(data.is_intro){
					that.previeWin = true;
					that.$refs.preview.bindData(data.uid,2);
				}else{
					Message.warning("未上传")
				}
			},
			closePreview(){
				that.previeWin = false;
			},
			// 数据转出
			dataList(){
				that.tableData = [];
				that.totalPage = 0;
				that.getdata.page = 1;
				if(that.transferType==1){
					// 转出
					dygl.transferOutList(that.getdata).then(res => {
						if(res.data.pagedata.length>0){
							that.tableData = res.data.pagedata;
							that.totalPage = res.data.count;
						}else{
							that.tableData = [];
							that.totalPage = 0;
						}
					})
				}else{
					// 转入
					dygl.transferIntoList(that.getdata).then(res => {
						if(res.data.pagedata.length>0){
							that.tableData = res.data.pagedata;
							that.totalPage = res.data.count;
						}else{
							that.tableData = [];
							that.totalPage = 0;
						}
					})
				}
			},
			// 分页查询
			changedata(current){
				that.getdata.page = current;
				that.dataList();
			},
			// 详情
			detail(data){
				// if(data.transfer == 2){
					that.$router.push({
						path:'/gxzy_detail',
						query:{
							id:data.id
						}
					})
				// }
			},
			// 导出表格
			daochu(){
				if(that.tableData.length == 0){
					Message({
						type:"warning",
						message:"暂无可导出的数据"
					})
				}else{
					dwgl.exportPartyOrgan(that.getdata);
				}
			}
		},
		mounted() {
			that.dataList();
		}
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.switchBar{
			width: 100%;
			height: 40px;
			line-height: 40px;
			margin-bottom: 20px;
			border-bottom: 1px solid #DDDDDD;
			span{
				cursor: pointer;
				display: inline-block;
				line-height: 40px;
				font-size: 16px;
				margin-right: 20px;
				padding: 0 20px;
				font-weight: bold;
			}
			span:hover{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
			.selectSwitch{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
		}
	}
</style>

